/* DE BIJNA-BAR — voortgang naar de eerstvolgende cadeaudrempel plus hoogstens
   één add-on die de klant er precies overheen brengt.

   HET MEETBEDRAG
   som van line_price over alle wagenregels, min de regels met de cadeau-
   varianten (sokken, boxershorts) en Verzekerde verzending. Nooit
   cart.total_price: die is al verlaagd door de cadeaukorting van Kaching en
   zou de bar laten liegen zodra er een cadeau in de wagen ligt.

   DE DRIE FASEN
   1. onder drempel 1  -> balk naar €80 + de closer (CK Boxershort Set).
      Is de gap kleiner dan of gelijk aan de prijs van de closer, dan belooft
      de zin het cadeau erbij; anders alleen "nog zoveel te gaan".
   2. tussen de drempels -> balk naar €150 + hoogstens één product uit de
      collectie tussen €29,95 en €39,95 dat de gap sluit. Geen sokken (heeft
      hij al gratis) en geen boxershorts (dat is het cadeau zelf).
   3. boven drempel 2  -> alleen de bevestiging, geen add-on.

   WAT ER NOOIT AANGEBODEN WORDT
   producten met de tag 'geen-upsell' (de sigarenhouders en de "op aanvraag"-
   artikelen), en een add-on die duurder is dan het meetbedrag van de wagen.

   DE HARDE REGEL
   magAanbieden() weigert een variant die het cadeau is van de drempel die hij
   ontgrendelt, en een variant die niet koopbaar is (available). Die controle
   draait twee keer: bij het kiezen van de add-on en nog een keer vlak voor
   /cart/add.js. Koopbaarheid komt bij het aanklikken vers uit
   /products/<handle>.js, niet uit inventory_quantity — zie de toelichting bij
   de functie zelf.

   BIJWERKEN
   Na elke eigen toevoeging halen we /cart.js opnieuw op; de oude wagenstand
   wordt nooit hergebruikt. Daarnaast luisteren we op cart:updated en
   ajaxProduct:added (de wagen-events van dit thema) en doen we na een eigen
   toevoeging nog één late meting, omdat Kaching de cadeauregel pas een
   moment later toevoegt. */
(function () {
  'use strict';
  if (window.LfBijnaBar) { return; }

  var mounts = [];
  var cfg = null;
  var meet = 0;
  var bezig = null;

  /* ---------- geld ---------- */
  /* De money-opmaak van het thema, niet zelf verzonnen: theme.Currency.formatMoney
     met het formaat uit theme.settings. Is theme.js er nog niet, dan draaien we
     hetzelfde formaat (shop.money_format, via data-geldvorm) door dezelfde
     placeholders. */
  function centenNaarTekst(centen, decimalen, duizend, komma) {
    var n = Math.abs(centen) / 100;
    var vast = n.toFixed(decimalen);
    var delen = vast.split('.');
    var heel = delen[0].replace(/\B(?=(\d{3})+(?!\d))/g, duizend);
    return decimalen > 0 ? heel + komma + delen[1] : heel;
  }

  function geldTerugval(centen, vorm) {
    var f = String(vorm || '€{{amount_with_comma_separator}}');
    return f.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, sleutel) {
      switch (sleutel) {
        case 'amount': return centenNaarTekst(centen, 2, ',', '.');
        case 'amount_no_decimals': return centenNaarTekst(centen, 0, ',', '.');
        case 'amount_with_comma_separator': return centenNaarTekst(centen, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return centenNaarTekst(centen, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return centenNaarTekst(centen, 2, "'", '.');
        default: return centenNaarTekst(centen, 2, '.', ',');
      }
    });
  }

  function geld(centen) {
    var c = Math.max(0, Math.round(centen));
    var vorm = (window.theme && theme.settings && theme.settings.moneyFormat) || (cfg && cfg.geldvorm);
    if (window.theme && theme.Currency && typeof theme.Currency.formatMoney === 'function') {
      return theme.Currency.formatMoney(c, vorm);
    }
    return geldTerugval(c, vorm);
  }

  /* ---------- hulpjes ---------- */
  function vul(sjabloon, sleutel, waarde) { return String(sjabloon).split('%' + sleutel + '%').join(waarde); }
  function veilig(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }
  function json(s, terugval) { try { return JSON.parse(s); } catch (e) { return terugval; } }

  function leesCfg(el) {
    var d = el.dataset;
    return {
      d1: parseInt(d.d1, 10) || 8000,
      d2: parseInt(d.d2, 10) || 15000,
      cadeau1: parseInt(d.cadeau1, 10) || 0,
      cadeau2: parseInt(d.cadeau2, 10) || 0,
      verzekerd: parseInt(d.verzekerd, 10) || 0,
      geldvorm: d.geldvorm || '',
      cadeau1Prijs: parseInt(d.cadeau1Prijs, 10) || 0,
      closerHandle: d.closerHandle || '',
      zoekpad: d.zoekpad || '/collections/all',
      kandidaten: json(d.kandidaten, []) || [],
      t: {
        a1: d.tA1, a1_kaal: d.tA1k, a2: d.tA2, b: d.tB, c: d.tC,
        vanaf: d.tVanaf, knop: d.tKnop, bezig: d.tBezig, maat: d.tMaat, fout: d.tFout,
        m1: d.tM1, m2: d.tM2
      }
    };
  }

  /* ---------- meten ---------- */
  function negeer(variantId) {
    return variantId === cfg.cadeau1 || variantId === cfg.cadeau2 || variantId === cfg.verzekerd;
  }

  function meten(c) {
    var items = (c && c.items) || [];
    var som = 0;
    for (var i = 0; i < items.length; i++) {
      if (!negeer(items[i].variant_id)) { som += items[i].line_price; }
    }
    return som;
  }

  /* ---------- de harde regel ---------- */
  /* Eén functie beslist of een variant aangeboden mag worden. Drie voorwaarden,
     alledrie hard, en met opzet streng: ontbreekt er iets, dan is het antwoord
     nee.

     1. de variant bestaat
     2. hij is niet het cadeau van de drempel die hij ontgrendelt, en ook geen
        cadeauvariant of de verzendbescherming
     3. hij is KOOPBAAR

     Punt 3 was tot 8 september 2026 inventory_quantity > 0. Dat is hier de
     verkeerde maatstaf: de winkel werkt met dropship en 7-10 werkdagen
     levertijd, dus het voorraadgetal zegt niets. 377 van de 544 actieve
     producten (69%) staan op 0 of lager, terwijl er maar 79 (15%) ergens echt
     niet koopbaar zijn — de knop bleef dus weg bij zo'n 300 producten die
     gewoon te koop zijn.

     Wat er nu geldt is `available`: in Liquid variant.available, hier het veld
     available uit /products/<handle>.js. Dat is wat Shopify zelf voor de
     koopknop gebruikt — waar bij voorraad > 0 én bij inventoryPolicy CONTINUE,
     onwaar zodra de variant niet te koop is. */
  function magAanbieden(variantId, cadeauVanDeDrempel, koopbaar) {
    var v = parseInt(variantId, 10);
    if (!(v > 0)) { return false; }
    if (v === parseInt(cadeauVanDeDrempel, 10)) { return false; }
    if (negeer(v)) { return false; }
    return koopbaar === true;
  }

  /* De koopbaarheid zoals /products/<handle>.js hem het laatst gaf, per
     variant. Hieruit haalt de controle vlak vóór /cart/add.js zijn antwoord,
     zodat ook die laatste toets op het product-JSON staat en niet op een
     vlaggetje dat in de knop is meegebakken. */
  var koopbaarheid = {};

  /* Producten waarvan bij het aanklikken bleek dat er geen enkele maat meer te
     koop is. Die worden op deze pagina niet nog eens aangeboden. */
  var uitverkocht = {};

  /* Bleek de aangeklikte add-on nergens meer te koop, dan gaat de knop weg en
     blijft alleen de balk staan — we schuiven er niet stilletjes een ander
     product onder de vinger van de klant. De blokkade geldt voor de huidige
     wagenstand; zodra de wagen verandert wordt hij opgeheven, terwijl
     uitverkocht[] dat ene product wel uitgesloten houdt. */
  var addonGeblokkeerd = false;

  /* De koopbare varianten van een product, altijd vers uit het product-JSON. */
  function koopbareVarianten(handle, cadeauVanDeDrempel) {
    return fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) { throw new Error('product'); } return r.json(); })
      .then(function (prod) {
        var uit = [];
        (prod.variants || []).forEach(function (v) {
          koopbaarheid[v.id] = v.available === true;
          if (magAanbieden(v.id, cadeauVanDeDrempel, v.available === true)) {
            uit.push({ id: v.id, t: v.title, p: v.price });
          }
        });
        return uit;
      });
  }

  /* ---------- wat tonen we ---------- */

  /* DE DREMPELTOETS — de regel waar alles op staat of valt.

     Een add-on mag alleen verschijnen als hij de klant écht over de drempel
     tilt die de balk noemt:

         meetbedrag + prijs van de add-on >= drempel

     Haalt hij dat niet, dan komt er geen knop en geen maten — alleen de balk.
     Geen uitzondering, ook niet voor de closer.

     WAAROM DIT ER STAAT
     Tot 8 september 2026 werd de closer (€14,95) onder de eerste drempel altijd
     getoond, met alleen een andere tekst als hij de gap niet dichtte. Bij een
     wagen van €59,90 stond er dus "nog €20,10 tot je gratis Nike sokken" met
     daaronder een knop van €14,95: tikken bracht de klant op €74,85, hij betaalde
     €14,95 en kreeg nog steeds geen sokken. Boven de eerste drempel gold deze
     toets al wel — daar bleef de knop weg zodra geen enkel kandidaatproduct de
     gap dichtte. Nu geldt hij overal. */
  function haaltDeDrempel(kandidaat, drempel) {
    return (meet + kandidaat.p) >= drempel;
  }

  /* DE REDELIJKHEIDSGRENS
     Een add-on mag de drempel met hoogstens dit bedrag overschrijden. Zonder
     die grens zou iemand voor €45 bijkopen om €15 aan cadeau te ontgrendelen.
     Eén regel om te wisselen; bewust geen instelling in de themabewerker. */
  var GRENS = 2000;   /* €20,00 in centen */

  function overschrijding(kandidaat, drempel) {
    return (meet + kandidaat.p) - drempel;
  }

  /* DE VERHOUDING TOT DE WAGEN
     De add-on mag niet duurder zijn dan wat er al in de wagen ligt:

         prijs van de add-on <= meetbedrag

     De redelijkheidsgrens hierboven kijkt naar de overschrijding van de
     drempel, niet naar de verhouding tot de wagen, en die twee lopen uiteen
     zodra de gap groot is. Bij een wagen van €29,95 kwam er op 8 september 2026
     een add-on van €52,95 uit — 177% van de wagen, netjes binnen de grens want
     de overschrijding was €2,90 — om €14,95 aan sokken te ontgrendelen. Haalt
     geen enkele kandidaat deze regel, dan geen knop.

     Bij een lege wagen is het meetbedrag nul en valt hier dus alles af; daar
     kwam toch al geen add-on, want niets haalt in z'n eentje de drempel. */
  function nietDuurderDanDeWagen(kandidaat) {
    return kandidaat.p <= meet;
  }

  /* ---------- de kandidaten uit de catalogus ---------- */

  /* Per wagenstand één verzoek naar templates/collection.bijnabar.liquid, met
     het prijsvenster van deze stand: vanaf de gap tot de gap plus de
     redelijkheidsgrens. Shopify filtert en sorteert (oplopend op prijs), dus
     welke producten terugkomen hangt af van de prijs en niet van waar ze in de
     catalogus staan.

     WAAROM ÉÉN PAGINA GENOEG IS
     Er wordt op productprijs oplopend gesorteerd, en de prijs waarmee wij
     rekenen — de goedkoopste koopbare maat — ligt altijd op of boven die
     sorteerprijs. De goedkoopste bruikbare kandidaat staat daarom in de eerste
     vijftig. Levert die vijftig er tóch geen op en zijn er meer pagina's, dan
     halen we er nog één; verder gaan we niet. */
  var gevonden = null;      /* { meet: n, lijst: [], totaal: n, bekeken: n, overgeslagen: n } */
  var zoekBezig = 0;

  function zoekUrl(gap, pagina) {
    var lo = (gap / 100).toFixed(2);
    var hi = ((gap + GRENS) / 100).toFixed(2);
    return cfg.zoekpad + '?view=bijnabar' +
      '&filter.v.price.gte=' + lo +
      '&filter.v.price.lte=' + hi +
      '&sort_by=price-ascending' +
      (pagina > 1 ? '&page=' + pagina : '');
  }

  function haalPagina(gap, pagina) {
    return fetch(zoekUrl(gap, pagina), { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) { throw new Error('zoeken'); } return r.json(); });
  }

  function zoekKandidaten(gap, drempel) {
    return haalPagina(gap, 1).then(function (a) {
      var lijst = a.producten || [];
      var bruikbaar = lijst.filter(function (k) { return (meet + k.p) >= drempel; });
      if (bruikbaar.length || a.paginas < 2) {
        return { lijst: lijst, totaal: a.gevonden, bekeken: a.bekeken, overgeslagen: a.overgeslagen || 0 };
      }
      return haalPagina(gap, 2).then(function (b) {
        return {
          lijst: lijst.concat(b.producten || []),
          totaal: a.gevonden,
          bekeken: a.bekeken + (b.bekeken || 0),
          overgeslagen: (a.overgeslagen || 0) + (b.overgeslagen || 0)
        };
      });
    });
  }

  /* WELKE VAN DE KANDIDATEN DIE DE DREMPEL HALEN
     De goedkoopste: de kleinste extra uitgave voor de klant. Eén regel om te
     wisselen naar de duurste — zet er `a.p > b.p`. Bewust geen instelling in de
     themabewerker: dit is een keuze die je één keer maakt, geen knop waar per
     ongeluk aan gedraaid wordt. */
  function beter(a, b) { return a.p < b.p; }

  /* Bij gelijke prijs wint de eerste uit de lijst: de closer, en daarna de
     bestsellersvolgorde van de collectie. */
  function kiesAddon(drempel, cadeauVanDeDrempel, closerOverslaan) {
    if (addonGeblokkeerd) { return null; }
    /* De closer uit Liquid plus wat de catalogus voor deze wagenstand opleverde.
       De closer krijgt geen voorrang: hij doorloopt dezelfde toetsen. */
    var poel = cfg.kandidaten.slice();
    if (gevonden && gevonden.meet === meet) { poel = poel.concat(gevonden.lijst); }

    var beste = null;
    var gezien = {};
    for (var i = 0; i < poel.length; i++) {
      var k = poel[i];
      if (gezien[k.h]) { continue; }
      gezien[k.h] = true;
      if (uitverkocht[k.h]) { continue; }
      /* Boven de eerste drempel is het cadeau een boxershort; dan bieden we de
         closer niet aan, want dat zijn ook boxershorts. */
      if (closerOverslaan && k.h === cfg.closerHandle) { continue; }
      /* De tag 'geen-upsell'. De catalogusweergave laat zulke producten al weg;
         dit vangt de closer uit Liquid, die gemarkeerd binnenkomt in plaats van
         weggelaten. */
      if (k.x === true) { continue; }
      if (!haaltDeDrempel(k, drempel)) { continue; }
      if (overschrijding(k, drempel) > GRENS) { continue; }
      if (!nietDuurderDanDeWagen(k)) { continue; }
      /* Bij één koopbare maat weten we de variant al; die is op available
         gefilterd. Bij meer maten beslist het product-JSON bij het aanklikken. */
      if (k.n === 1 && !magAanbieden(k.vid, cadeauVanDeDrempel, true)) { continue; }
      if (!beste || beter(k, beste)) { beste = k; }
    }
    return beste;
  }

  function plan() {
    if (meet >= cfg.d2) { return { fase: 3, pct: 100 }; }

    if (meet >= cfg.d1) {
      var kand2 = kiesAddon(cfg.d2, cfg.cadeau2, true);
      return {
        fase: 2,
        gap: cfg.d2 - meet,
        pct: (meet / cfg.d2) * 100,
        mijlpaal: (cfg.d1 / cfg.d2) * 100,
        addon: kand2 ? { k: kand2, prijs: kand2.p } : null
      };
    }

    var kand1 = kiesAddon(cfg.d1, cfg.cadeau1, false);
    return {
      fase: 1,
      gap: cfg.d1 - meet,
      pct: (meet / cfg.d1) * 100,
      addon: kand1 ? { k: kand1, prijs: kand1.p } : null
    };
  }

  /* WAT ER ALS PRIJS OP HET SCHERM KOMT
     Heeft het product één prijs, dan die prijs. Loopt hij van laag naar hoog —
     Essentials 1977 Zomerset gaat van €29,95 tot €55,95 — dan "vanaf €29,95",
     en staat op elke maatknop wat die maat kost. Anders zou er €29,95 in de zin
     staan terwijl de klant €55,95 afrekent. */
  function prijsTekst(k) {
    if (!k.pmax || k.pmax === k.p) { return geld(k.p); }
    return vul(cfg.t.vanaf, 'prijs', geld(k.p));
  }

  function zin(p) {
    if (p.fase === 3) { return cfg.t.c; }
    if (p.fase === 2) { return vul(cfg.t.b, 'bedrag', geld(p.gap)); }
    /* Onder de eerste drempel: is er een add-on, dan haalt hij de drempel — dat
       heeft kiesAddon() al afgedwongen — dus de belofte mag hard. Is er geen
       add-on, dan alleen hoeveel er nog te gaan is. */
    if (!p.addon) { return vul(cfg.t.a2, 'bedrag', geld(p.gap)); }
    /* Kennen we de cadeauwaarde niet, dan de zin zonder die zinsnede, in plaats
       van een verzonnen bedrag. */
    var waarde = cadeauWaarde();
    var s = waarde ? cfg.t.a1 : cfg.t.a1_kaal;
    s = vul(s, 'bedrag', geld(p.gap));
    s = vul(s, 'naam', p.addon.k.t);
    s = vul(s, 'prijs', prijsTekst(p.addon.k));
    if (waarde) { s = vul(s, 'waarde', geld(waarde)); }
    return s;
  }

  /* De cadeauwaarde komt uit de wagen zodra het cadeau erin ligt, en daarvoor
     uit de prijs die Liquid onderweg door de collectie heeft opgepikt. Nul
     betekent: onbekend. */
  var cadeauPrijs = 0;
  function cadeauWaarde() { return cadeauPrijs || cfg.cadeau1Prijs || 0; }

  /* ---------- tekenen ---------- */
  function balk(p) {
    var pct = Math.max(0, Math.min(100, p.pct || 0));
    var html = '<span class="lf-bb__spoor"><span class="lf-bb__vulling" style="width:' + pct.toFixed(1) + '%"></span>';
    if (p.fase === 2 && p.mijlpaal) {
      html += '<span class="lf-bb__mijlpaal" style="left:' + p.mijlpaal.toFixed(1) + '%" title="' + veilig(cfg.t.m1) + '"></span>';
    }
    return html + '</span>';
  }

  function addonHtml(p) {
    if (!p.addon) { return ''; }
    var a = p.addon;
    var naam = a.k.t;
    var url = a.k.u;
    var foto = a.k.f;
    var handle = a.k.h;
    return '<div class="lf-bb__addon" data-lf-bb-addon data-handle="' + veilig(handle) + '">' +
      (foto ? '<a href="' + veilig(url) + '" tabindex="-1"><img class="lf-bb__foto" src="' + veilig(foto) + '" alt="" loading="lazy" width="44" height="44"></a>' : '') +
      '<span class="lf-bb__vak">' +
        '<a class="lf-bb__naam" href="' + veilig(url) + '">' + veilig(naam) + '</a>' +
        '<span class="lf-bb__prijs">' + veilig(prijsTekst(a.k)) + '</span>' +
      '</span>' +
      '<button type="button" class="lf-bb__knop" data-lf-bb-knop>' + veilig(cfg.t.knop) + '</button>' +
    '</div>';
  }

  function teken() {
    var p = plan();
    var html = '<p class="lf-bb__zin">' + veilig(zin(p)) + '</p>' + (p.fase === 3 ? '' : balk(p)) + addonHtml(p);
    mounts.forEach(function (el) {
      if (el.getAttribute('data-html') === html) { return; }
      el.innerHTML = html;
      el.setAttribute('data-html', html);
      el.setAttribute('data-fase', String(p.fase));
    });
  }

  /* ---------- verversen ---------- */
  function verwerk(c) {
    addonGeblokkeerd = false;
    meet = meten(c);
    var items = (c && c.items) || [];
    for (var i = 0; i < items.length; i++) {
      if (items[i].variant_id === cfg.cadeau1) { cadeauPrijs = items[i].price || items[i].original_price || 0; }
    }
    teken();
    return zorgVoorKandidaten();
  }

  /* De balk staat er meteen; de add-on komt zodra de catalogus antwoordt. Die
     volgorde is met opzet: het bedrag dat de klant moet lezen hoeft niet op een
     netwerkverzoek te wachten, en de add-on verschijnt eronder, dus hij duwt
     niets weg dat al gelezen was. */
  function zorgVoorKandidaten() {
    var p = plan();
    if (p.fase === 3) { gevonden = null; return Promise.resolve(); }
    if (gevonden && gevonden.meet === meet) { return Promise.resolve(); }
    if (zoekBezig === meet) { return Promise.resolve(); }
    var stand = meet;
    var drempel = p.fase === 2 ? cfg.d2 : cfg.d1;
    zoekBezig = stand;
    return zoekKandidaten(p.gap, drempel)
      .then(function (res) {
        /* Is de wagen ondertussen veranderd, dan hoort dit antwoord bij een
           stand die niet meer bestaat. */
        if (stand !== meet) { return; }
        gevonden = { meet: stand, lijst: res.lijst, totaal: res.totaal, bekeken: res.bekeken, overgeslagen: res.overgeslagen };
        teken();
      })
      .catch(function () { /* netwerk weg: alleen de closer doet mee */ })
      .then(function () { if (zoekBezig === stand) { zoekBezig = 0; } });
  }

  function ververs() {
    if (bezig) { return bezig; }
    bezig = fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(verwerk)
      .catch(function () { /* netwerk weg: laatste stand laten staan */ })
      .then(function () { bezig = null; });
    return bezig;
  }

  /* ---------- toevoegen ---------- */
  function fout(vak, tekst) {
    var p = vak.querySelector('.lf-bb__fout') || document.createElement('p');
    p.className = 'lf-bb__fout';
    p.textContent = tekst || cfg.t.fout;
    vak.parentNode.appendChild(p);
  }

  function voegVariantToe(variantId, cadeauVanDeDrempel, knop, vak) {
    /* Tweede keer de harde regel, vlak voor het versturen. De koopbaarheid komt
       uit het product-JSON dat koopbareVarianten() net heeft opgehaald. */
    if (!magAanbieden(variantId, cadeauVanDeDrempel, koopbaarheid[variantId] === true)) { return Promise.resolve(); }
    var terug = knop ? knop.textContent : '';
    if (knop) { knop.disabled = true; knop.textContent = cfg.t.bezig; }
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (r) {
        if (!r.ok) { return r.json().then(function (d) { throw new Error((d && d.description) || ''); }); }
        return r.json();
      })
      .then(function () {
        document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
        if (window.lfCart && window.lfCart.sync) { window.lfCart.sync(); }
        /* Verse wagen ophalen, en nog één keer wat later: Kaching zet de
           cadeauregel er pas na zijn eigen ronde bij. */
        return ververs().then(function () { window.setTimeout(ververs, 1200); });
      })
      .catch(function (e) { if (vak) { fout(vak, (e && e.message) || cfg.t.fout); } })
      .then(function () { if (knop) { knop.disabled = false; knop.textContent = terug; } });
  }

  function matenHtml(varianten) {
    /* Verschillen de maten in prijs, dan staat op elke knop wat die maat kost.
       Bij één prijs zou dat alleen ruis zijn; die staat al bij de naam. */
    var prijzen = varianten.map(function (v) { return v.p; });
    var verschilt = Math.min.apply(null, prijzen) !== Math.max.apply(null, prijzen);
    return '<div class="lf-bb__maten"><p class="lf-bb__maten-kop">' + veilig(cfg.t.maat) + '</p><div class="lf-bb__maat-rij">' +
      varianten.map(function (v) {
        return '<button type="button" class="lf-bb__maat" data-lf-bb-maat data-id="' + v.id + '">' +
          veilig(v.t) + (verschilt ? ' <span class="lf-bb__maat-prijs">' + veilig(geld(v.p)) + '</span>' : '') +
          '</button>';
      }).join('') + '</div></div>';
  }

  /* Bij het aanklikken halen we het
     product-JSON op en laten magAanbieden() bepalen welke maten overblijven.
     Zo staat de beslissing om iets toe te voegen altijd op verse gegevens van
     Shopify zelf, niet op de momentopname die Liquid bij het renderen maakte.

     Eén maat over: die gaat er direct in. Meer maten: de klant kiest.
     Geen enkele maat over: de knop verdwijnt en alleen de balk blijft staan. */
  function klikKnop(knop) {
    var vak = knop.closest('[data-lf-bb-addon]');
    if (!vak || knop.disabled) { return; }
    var p = plan();
    if (!p.addon) { return; }

    var cadeau = p.fase === 2 ? cfg.cadeau2 : cfg.cadeau1;
    var handle = p.addon.k.h;
    var terug = knop.textContent;
    knop.disabled = true; knop.textContent = cfg.t.bezig;

    koopbareVarianten(handle, cadeau)
      .then(function (vs) {
        if (!vs.length) {
          uitverkocht[handle] = true;
          addonGeblokkeerd = true;
          teken();
          return;
        }
        if (vs.length === 1) { return voegVariantToe(vs[0].id, cadeau, null, vak); }
        if (!vak.parentNode.querySelector('.lf-bb__maten')) {
          vak.insertAdjacentHTML('afterend', matenHtml(vs));
        }
      })
      .catch(function () { fout(vak, cfg.t.fout); })
      .then(function () { knop.disabled = false; knop.textContent = terug; });
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) { return; }
    var maat = e.target.closest('[data-lf-bb-maat]');
    if (maat) {
      e.preventDefault();
      var vak = maat.closest('.lf-bb').querySelector('[data-lf-bb-addon]');
      var p = plan();
      var cadeau = p.fase === 2 ? cfg.cadeau2 : cfg.cadeau1;
      voegVariantToe(parseInt(maat.getAttribute('data-id'), 10), cadeau, maat, vak);
      return;
    }
    var knop = e.target.closest('[data-lf-bb-knop]');
    if (knop) { e.preventDefault(); klikKnop(knop); }
  });

  /* ---------- wagen-events van dit thema ----------
     De winkelwagenlade rendert NA deze events haar eigen Liquid over onze
     uitkomst heen. Een enkele ververs() op t+60 ms is daarom niet genoeg: op
     11 september 2026 bleef .lf-bb__zin negen seconden lang op de Liquid-waarde
     "Nog EUR 80,00" staan bij een wagentje van EUR 44,95, waar EUR 35,05 hoorde
     te staan. Alleen dit ene pad ging mis; een hoeveelheidswijziging in de lade
     rekende wel goed. Zelfde staffel als bij het cadeaubalkje op 10 september,
     plus een observer op de lade zelf. */
  function staffel() {
    start();
    window.setTimeout(start, 400);
    window.setTimeout(start, 1500);
  }

  document.addEventListener('cart:updated', function () { window.setTimeout(staffel, 30); });
  document.addEventListener('ajaxProduct:added', function () { window.setTimeout(staffel, 60); });
  window.addEventListener('pageshow', function (e) { if (e.persisted) { ververs(); } });

  /* DE LADE IS HET SIGNAAL, NIET HET EVENT.
     Op 11 september 2026 gemeten op een vers geladen productpagina: tikken op
     TOEVOEGEN AAN WINKELWAGEN stuurt NOCH cart:updated NOCH ajaxProduct:added.
     Beide luisteraars hierboven vuren op die route dus nooit, en het bedrag
     bleef op de stand van het laden staan — bij een leeg wagentje is dat
     "Nog EUR 80,00", ook nadat er EUR 44,95 in lag. De twee events blijven
     staan voor de routes die ze wel sturen (onder meer onze eigen cadeau-
     toevoeging), maar we vertrouwen er niet meer op.

     Wat wel altijd gebeurt: de lade verandert. Hij gaat open, of zijn regels
     worden opnieuw getekend. Daar hangen we aan, en dan halen we een verse
     /cart.js op in plaats van alleen opnieuw te tekenen.

     Geen kringloop: onze eigen tekening gaat via teken(), dat een ongewijzigde
     uitkomst overslaat (data-html). Mutaties binnen onze eigen aanknooppunten
     slaan we bovendien expliciet over, zodat een hertekening geen tweede
     netwerkverzoek uitlokt. */
  var ladeBewaakt = false;
  function bewaakDeLade() {
    if (ladeBewaakt || !('MutationObserver' in window)) { return; }
    var lade = document.getElementById('LfCartDrawer');
    if (!lade) { return; }
    ladeBewaakt = true;
    var wacht = 0;
    new MutationObserver(function (lijst) {
      var vanBuiten = false;
      for (var i = 0; i < lijst.length; i++) {
        var doel = lijst[i].target;
        var node = doel && doel.nodeType === 1 ? doel : (doel && doel.parentElement);
        if (!node || !node.closest || !node.closest('[data-lf-bijnabar]')) { vanBuiten = true; break; }
      }
      if (!vanBuiten) { return; }
      window.clearTimeout(wacht);
      wacht = window.setTimeout(function () {
        if (!hermonteer()) { return; }
        ververs();
      }, 60);
    }).observe(lade, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  }

  /* ---------- aanknooppunten ---------- */
  /* Nieuwe aanknooppunten oppakken zonder het netwerk op te gaan. De lade kan
     haar inhoud vervangen; dan is het knooppunt dat we kenden losgeraakt. */
  function hermonteer() {
    var els = document.querySelectorAll('[data-lf-bijnabar]');
    for (var i = 0; i < els.length; i++) {
      if (els[i].__lfBb) { continue; }
      els[i].__lfBb = true;
      if (!cfg) { cfg = leesCfg(els[i]); }
      mounts.push(els[i]);
    }
    /* Losgeraakte knooppunten eruit, anders groeit de lijst bij elke render. */
    for (var j = mounts.length - 1; j >= 0; j--) {
      if (!document.contains(mounts[j])) { mounts.splice(j, 1); }
    }
    return mounts.length;
  }

  function start() {
    if (!hermonteer()) { return; }
    ververs();
  }

  window.LfBijnaBar = {
    ververs: ververs,
    meetbedrag: function () { return meet; },
    plan: function () { return cfg ? plan() : null; },
    magAanbieden: magAanbieden,
    grens: function () { return GRENS; },
    /* Voor het nameten: hoeveel producten de catalogus voor deze wagenstand
       opleverde, hoeveel er daadwerkelijk bekeken zijn, en hoeveel er wegens de
       tag 'geen-upsell' zijn overgeslagen. */
    doorzocht: function () { return gevonden && gevonden.meet === meet ? { totaal: gevonden.totaal, bekeken: gevonden.bekeken, bruikbaar: gevonden.lijst.length, overgeslagen: gevonden.overgeslagen } : null; }
  };

  function opstarten() { start(); bewaakDeLade(); }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', opstarten); }
  else { opstarten(); }
})();
